import { SyncAll } from "../../assets/SyncAll";

type Props = {
    label: string;
    syncing?: boolean;
    disabled?: boolean;
    onClick?: () => void;
    className?: string;
    iconColor?: string;
};

/**
 * "Sync all" trigger shared by the store card and the report force-sync. Shows the sync icon
 * next to its label, and swaps the icon for a spinner while a sync is in progress (which also
 * disables the button). Styling and labels are supplied by each caller.
 */
export default function SyncAllButton({
    label,
    syncing = false,
    disabled = false,
    onClick,
    className,
    iconColor = "#fff",
}: Props) {
    return (
        <button
            type="button"
            className={className}
            onClick={onClick}
            disabled={disabled || syncing}
        >
            {syncing
                ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                : <SyncAll color={iconColor} />}
            <span>{label}</span>
        </button>
    );
}
